
import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import ClubsTable from "./clubs/ClubsTable";
import ClubDialog from "./clubs/ClubDialog";
import { useClubManagement } from "./clubs/useClubManagement";

const AdminClubs = () => {
  const {
    clubs,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    isSubmitting,
    isDeleting,
    currentClub,
    handleInputChange,
    handleImageChange,
    handleCreate,
    handleEdit,
    handleSubmit,
    handleDelete,
  } = useClubManagement();

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Clubs</h2>
        <Button onClick={handleCreate}>
          <Plus className="h-4 w-4 mr-2" />
          Add Club
        </Button>
      </div>

      <ClubsTable
        clubs={clubs}
        loading={loading}
        isDeleting={isDeleting}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />

      <ClubDialog
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        currentClub={currentClub}
        handleInputChange={handleInputChange}
        handleImageChange={handleImageChange}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
};

export default AdminClubs;
